<template>
  <v-container fluid>
    <v-simple-table class="table" 
      v-if="!showModelSignalViewer"
      fixed-header 
      height="100%" >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="table-header">Model</th>
            <th class="table-header">Last Updated</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="model in models" :key="model.name" @click="getSignalModel(model.id, model.description)">
            <td class="table-row">{{model.description}}</td>
            <td class="table-row">{{model.updated_at}}</td>
          </tr>
        </tbody>    
      </template>
      <div v-if="empty">No Models Available</div>
    </v-simple-table>
    <ModelSignalViewer 
      v-if="showModelSignalViewer"
      v-bind:modelId= "modelIdSelected"
      v-bind:title= "modelName"
      @close-modelSignalViewer="onModelSignalViewerClose"
      />
  </v-container>
</template>
<script>  
  import SystematicEconomics from '@/api/systematicEconomics'
  import ModelSignalViewer from '@/components/ModelSignalViewer.vue'
  import Vue from 'vue'

  export default {
    data: () => ({
      showModelSignalViewer:false,
      modelIdSelected:0,
      modelName:'',
      models: [],
      empty:false
    }),
    created(){
      this.getModels()
    },
    computed:{
      userId () {
          return this.$store.getters.getUser.id
      },
    },
    components:{
      ModelSignalViewer
    },
    methods:{
      getSignalModel(model_id,modelName){
        this.modelIdSelected = model_id
        this.modelName = modelName
        this.showModelSignalViewer=true
      },
      getModels () {
        const vm = this 
        return new Promise((resolve, reject) => {
          SystematicEconomics.getModels(this.userId).then(
            data => {
              vm.models = _.orderBy(data, ['name'], ['asc']);
              
              if(_.size(vm.models)==0){
                vm.empty=true
              }
              else{
                vm.empty=false
              }
            }
          )
        })
      },
      onModelSignalViewerClose(){
        this.showModelSignalViewer=false;
      },
    }
  }
</script>
<style>
.table {
  margin-top: 10px;
  margin-left: 30px;
}
.table-header{
  font-size: small !important;
  align-content: center;
  background-color: #d4d6e2 !important;
  font-weight: 600!important;
}
.table-row{
  font-size: small !important;
  align-content: center;
  background-color: transparent !important;
  font-weight: 400!important;
}
</style>